import turkishMessages from 'ra-language-turkish';

export const tr = {
  ...turkishMessages,
  ra: {
    ...turkishMessages.ra,
    page: {
      ...turkishMessages.ra?.page,
      dashboard: 'Kontrol Paneli',
      empty: 'Henüz kayıt bulunamadı',
      invite: 'Kullanıcı Davet Et',
      loading: 'Yükleniyor...',
    },
    message: {
      ...turkishMessages.ra?.message,
      loading: 'Lütfen bekleyin...',
      empty: 'Henüz gösterilecek veri yok.',
    },
    navigation: {
      ...turkishMessages.ra?.navigation,
      no_results: 'Görüntülenecek veri bulunamadı.',
    },
    action: {
      ...turkishMessages.ra?.action,
      save: 'Kaydet',
      delete: 'Sil',
      edit: 'Düzenle',
      create: 'Oluştur',
      cancel: 'İptal',
      refresh: 'Yenile',
      show: 'Göster',
      list: 'Listele',
      export: 'Dışa Aktar',
      add: 'Ekle',
      test: 'Test Et',
      reset: 'Sıfırla',
    },
  },
  resources: {
    'events-v2': {
      name: 'Etkinlikler (v2)',
      fields: {
        id: 'ID',
        name: 'Etkinlik Adı',
        type: 'Tür',
        venue: 'Mekan',
        city: 'Şehir',
        category: 'Kategori',
        startdate: 'Başlangıç Tarihi',
        enddate: 'Bitiş Tarihi',
        isVerified: 'Onaylı / Yayında',
        totalRevenue: 'Toplam Gelir',
        status: 'Durum',
      },
    },
    venues: {
      name: 'Mekan |||| Mekanlar',
      fields: {
        name: 'Mekan Adı',
        city: 'Şehir',
        address: 'Adres',
        capacity: 'Kapasite',
        phone: 'Telefon',
      },
    },
    users: {
      name: 'Kullanıcı |||| Kullanıcılar',
      fields: {
        id: 'ID',
        name: 'Ad Soyad',
        surname: 'Soyad',
        createDateTime: 'Tarih / Saat',
        gender: 'Cinsiyet',
        mobile: 'Telefon',
        email: 'E-posta',
        crole: 'Rol',
        country: 'Ülke',
        city: 'Şehir',
        verified: 'Onaylı',
        sales: 'Satışlar',
        edit: 'Düzenle',
      },
    },
    cities: {
      name: 'Şehir |||| Şehirler',
      fields: {
        name: 'Şehir Adı',
      },
    },
    organisationCompanies: {
      name: 'Organizasyon Şirketi |||| Organizasyon Şirketleri',
      fields: {
        name: 'Şirket Adı',
        email: 'E-posta',
        phone: 'Telefon',
      },
    },
    salePoints: {
      name: 'Satış Noktası |||| Satış Noktaları',
    },
    affiliates: {
      name: 'Satış Ortağı |||| Satış Ortakları',
    },
    saleAgents: {
      name: 'Satış Temsilcisi |||| Satış Temsilcileri',
    },
    promoters: {
      name: 'Organizör |||| Organizörler',
    },
    groupEvents: {
      name: 'Grup Etkinliği |||| Grup Etkinlikleri',
    },
    categories: {
      name: 'Kategori |||| Kategoriler',
    },
    subcategories: {
      name: 'Alt Kategori |||| Alt Kategoriler',
    },
    venueCategories: {
      name: 'Mekan Kategorisi |||| Mekan Kategorileri',
    },
    layouts: {
      name: 'Oturma Planı |||| Oturma Planları',
    },
    systemParameters: {
      name: 'Sistem Parametresi |||| Sistem Parametreleri',
    },
    appVersionConfigs: {
      name: 'Sürüm Konfigürasyonu |||| Sürüm Konfigürasyonları',
    },
    homeSections: {
      name: 'Ana Sayfa Bölümü |||| Ana Sayfa Bölümleri',
    },
    heros: {
      name: 'Ana Sayfa Özel Etkinlik Hero |||| Ana Sayfa Özel Etkinlik Hero',
    },
    events: {
      name: 'Etkinlik V1 Arşivi |||| Etkinlik V1 Arşivi',
    },
    dashboard: {
      name: 'Kontrol Paneli',
    },
    payments: {
      name: 'Ödeme |||| Ödemeler',
    },
    sessionEvents: {
      name: 'Session Etkinlik Arşivi |||| Session Etkinlik Arşivi',
    },
    affiliateForm: {
      name: 'Affiliate Başvurusu |||| Affiliate Başvuruları',
    },
    eventCreationApplications: {
      name: 'Başvuru |||| Başvurular',
    },
    featureds: {
      name: 'Öne Çıkan |||| Öne Çıkanlar',
    },
    eventTags: {
      name: 'Etkinlik Etiketi |||| Etkinlik Etiketleri',
    },
    eventLogs: {
      name: 'Etkinlik Logu |||| Etkinlik Logları',
    },
    verificationLogs: {
      name: 'Doğrulama Logu |||| Doğrulama Logları',
    },
    paymentLogs: {
      name: 'Satış Logu |||| Satış Logları',
    },
    stocks: {
      name: 'Stok |||| Stoklar',
    },
    pages: {
      name: 'Sayfa |||| Sayfalar',
    },
    news: {
      name: 'Haber |||| Haberler',
    },
    scripts: {
      name: 'Kod / Script |||| Kodlar ve Scriptler',
    },
    settlementCategories: {
      name: 'Muhasebe Kalemi |||| Muhasebe Kalemleri',
    },
    deleteUserRequests: {
      name: 'Silme Talebi |||| Silme Talepleri',
    },
    sales: {
      name: 'Satış |||| Satışlar',
      fields: {
        id: 'ID',
        'user.name': 'Kullanıcı',
        userName: 'Kullanıcı',
        createdate: 'Satış Tarihi',
        'event.name': 'Etkinlik Adı',
        eventName: 'Etkinlik Adı',
        userMobile: 'Kullanıcı Telefonu',
        channel: 'Kanal',
        soldBy: 'Satan Kişi/Nokta',
        payment: 'Ödeme (₺)',
        paymentType: 'Ödeme Türü',
        oid: 'Sipariş No',
        productsCount: 'Ürün Adedi',
        product: 'Ürün',
        coupon: 'Kupon',
        status: 'Durum',
        actions: 'İade Talebi / Durum',
      },
    },
    tickets: {
      name: 'Bilet |||| Biletler',
      fields: {
        id: 'ID',
        pnr: 'PNR',
        print: 'Bilet Yazdır',
        channel: 'Satış Kanalı',
        userName: 'Kullanıcı',
        eventName: 'Etkinlik Adı',
        created: 'Satış Tarihi',
        product: 'Ürün',
        productKey: 'Ürün Anahtarı',
        isUsed: 'Kullanıldı mı?',
        refund: 'İade',
      },
    },
    refundRequests: {
      name: 'İade Talebi |||| İade Talepleri',
      fields: {
        status: 'Durum',
        user: 'Kullanıcı',
        userEmail: 'E-posta',
        eventName: 'Etkinlik',
        productInfo: 'Bilet / Ürün',
        ticketPnr: 'PNR',
        createdate: 'İade Tarihi',
        processedBy: 'İade Eden',
      },
    },
  },
  refund: {
    title: 'İade Talepleri',
    view_refund: 'İadeyi Gör',
    view_detail: 'Detay Gör',
    status_waiting: 'İade bekliyor',
    status_scheduled: 'Planlandı',
    status_done: 'Tamamlandı',
    status_pending: 'Beklemede',
    status_approved: 'Onaylandı',
    status_rejected: 'Reddedildi',
    status_completed: 'Tamamlandı',
    status_failed: 'Başarısız',
  },
  report: {
    title: 'Satış Raporu',
    export_report: 'Rapor Al',
    venue_organisator_details: 'Mekan / Organizör Detayları',
    venue: 'Mekan',
    address: 'Adres',
    organisator_companies: 'Organizasyon Şirketleri',
    venue_prefix: 'Mekan',
    organisation_prefix: 'Organizasyon Şirketi',
    total: 'Toplam',
    summary: 'Özet',
    sales: 'Satışlar',
    total_sale: 'Toplam Satış',
    coupons: 'Kuponlar',
    total_discount: 'Toplam İndirim',
    remaining_payments: 'Kalan Ödemeler',
    total_remaining_amount: 'Toplam Kalan Tutar',
    total_revenue: 'Toplam Satış Tutarı',
    total_coupon_discount: 'Toplam Kupon İndirimi',
    organisator_sales_cash: 'Organizör Satışları (Elde)',
    sub_total: 'Ara Toplam',
    gise_fee: 'Gişe Kıbrıs Komisyonu',
    adjustments: 'Düzeltmeler',
    type: 'Tip',
    item_note: 'Kalem / Not',
    amount: 'Tutar',
    settlement_net: 'Düzeltme Net',
    total_payable: 'Toplam Ödenecek Tutar',
    add_expense: 'Gider Ekle',
    add_income: 'Gelir Ekle',
    pay: 'Ödeme Yap',
    no_seller_records: 'Bu kalemde satıcı kaydı yok.',
    seller: 'Satıcı',
    user: 'Kullanıcı',
    contact: 'İletişim',
    count: 'Adet',
    sales_count_suffix: 'satış',
    export_report_excel: 'Rapor Al — Excel',
    export_desc:
      'Excel’e girecek bölümleri seç. Her seçim ayrı sheet; kapak sayfasında etkinlik bilgisi ve seçilen bölümler yazar.',
    select_all: 'Tümünü Seç',
    clear_all: 'Temizle',
    selected_count: 'Seçilen (%{count})',
    download_excel: 'Excel İndir',
    used: 'kullanıldı',
    received: 'alındı',
    expense_used: 'Gider kullanıldı',
    income_received: 'Gelir alındı',
    expense: 'Gider (Harcanan)',
    income: 'Gelir (Giren)',
    add_expense_title: 'Gider Ekle',
    add_income_title: 'Gelir Ekle',
    add_expense_hint:
      'Bu tutar ilgili kalemden harcanmış / kullanılmış sayılır (ör. Reklam Bütçesi kullanıldı).',
    add_income_hint: 'Bu tutar elden alınmış / bütçeye girmiş sayılır (ör. Reklam Bütçesi alındı).',
    adjustment_detail: 'Düzeltme Detayı',
    date: 'Tarih',
    added_by: 'Ekleyen',
    documents: 'Evraklar',
    no_documents: 'Evrak yok',
    note: 'Not',
    add_document: 'Evrak Ekle',
    col_id: 'Ürün ID',
    col_title: 'Başlık',
    col_category: 'Kategori',
    col_price: 'Fiyat',
    'col_original-stock': 'Toplam Stok',
    col_sold: 'Satılan',
    col_stock: 'Kalan Stok',
    col_totalSale: 'Toplam Satış',
    col_totalRemaining: 'Toplam Kalan',
    col_code: 'Kupon Kodu',
    col_discount: 'İndirim (TL)',
    col_used: 'Kullanılan',
    col_totalDiscount: 'Toplam İndirim (TL)',
    line_affiliate: 'Affiliate satışları',
    line_sale_point: 'Sales Point satışları',
    line_promoter: 'Promoter satışları',
    line_manager_cash: 'Manager nakit',
    line_website: 'Website',
    line_mobile: 'Mobil',
    line_sale_agent: 'Satış Temsilcisi',
    line_affiliate_unbound: 'Affiliate (bağlı değil)',
    line_sale_point_unbound: 'Sales Point (bağlı değil)',
    line_other: 'Diğer',
  },
  sales: {
    title_session: 'Etkinlik Seansı / Satış Listesi',
    desc_session: 'Bu liste seçilen etkinlik seansı için tüm satışları gösterir.',
    title_event: 'Etkinlik / Satış Listesi',
    desc_event: 'Bu liste seçilen etkinlik için tüm satışları gösterir.',
    title_user: 'Kullanıcı / Satış Listesi',
    desc_user: 'Bu liste seçilen kullanıcı için tüm satışları gösterir.',
    title_default: 'Satış Listesi',
    desc_default:
      'Bu liste tarih/saat sırasına göre son 100 kaydı gösterir. Daha fazla satış için etkinlikler sayfasından sorgulama yapabilirsiniz.',
    detail_title: 'Satış Detayı',
    sale_id: 'Satış ID',
    order_id: 'Sipariş No',
    sale_date: 'Satış Tarihi',
    channel: 'Kanal',
    user: 'Kullanıcı',
    user_email: 'E-posta',
    user_mobile: 'Telefon',
    event: 'Etkinlik',
    payment_type: 'Ödeme Türü',
    payment_amount: 'Ödeme Tutarı',
    payment: 'Ödeme',
    products_count: 'Ürün Adedi',
    sold_by: 'Satan',
    status: 'Durum',
    redirecting_payment: 'İade ekranına yönlendiriliyor…',
    no_permission: 'Bu sayfayı görüntülemek için yetkiniz bulunmamaktadır.',
    status_awaiting: 'Beklemede',
    status_confirmed: 'Onaylandı',
    status_failed: 'Başarısız',
    status_refunded: 'İade Edildi',
    channel_website: 'Website',
    channel_mobile: 'Mobil',
    channel_sale_point: 'Satış Noktası',
    channel_sale_agent: 'Satış Temsilcisi',
    channel_org_promoter: 'Org. Promoter',
    channel_venue_promoter: 'Mekan Promoter',
    channel_affiliate: 'Affiliate',
    channel_org_manager: 'Org. Yönetici',
    channel_venue_manager: 'Mekan Yönetici',
    payment_credit_card: 'Kredi Kartı',
    payment_cash: 'Nakit',
    tickets_count: '%{count} bilet',
    refund_failed: 'İade başarısız',
    refund_pending: 'İade bekliyor',
    refund_in_progress: 'İade sürecinde',
    refund_success: 'İade süreci başarılı',
    bulk_refund_title: 'Toplu İade İşlemleri',
    bulk_refund_start: 'İadeyi Başlat',
    search_placeholder: 'Etkinlik, kullanıcı, e-posta, telefon, sipariş no veya kanal ara…',
    search_placeholder_user:
      'Bu kullanıcının satışlarında etkinlik adı, sipariş no veya kanal ara…',
  },
  tickets: {
    title_session: 'Etkinlik Seansı / Bilet Listesi',
    desc_session: 'Bu liste seçilen etkinlik seansı için tüm biletleri gösterir.',
    title_event: 'Etkinlik / Bilet Listesi',
    desc_event: 'Bu liste seçilen etkinlik için tüm biletleri gösterir.',
    title_default: 'Bilet Listesi',
    desc_default: 'Bu liste tarih/saat sırasına göre son 100 kaydı gösterir.',
    no_permission: 'Bu sayfayı görüntülemek için yetkiniz bulunmamaktadır.',
    usage_yes: 'Evet',
    usage_no: 'Hayır',
    refunded: 'İade edildi',
    refund_pending: 'İade bekliyor',
    search_placeholder: 'Etkinlik, kullanıcı adı, e-posta, telefon veya PNR ara…',
  },
  filters: {
    equals: 'Eşittir',
    contains: 'İçerir',
    is: 'Eşittir',
    on_or_after: 'Şu tarihten sonra',
    on_or_before: 'Şu tarihten önce',
    yes: 'Evet',
    no: 'Hayır',
    verified_is: 'Onay durumu',
    visible_is: 'Yayın durumu',
    verified_q: 'Onaylı mı?',
    visible_q: 'Yayında mı?',
    select_city: 'Şehir seç',
    select_type: 'Tür seç',
    select_category: 'Kategori seç',
    select_venue: 'Mekan seç',
    search_by_name: 'İsme göre ara',
  },
  cities: {
    // CRUD
    title: 'Şehirler',
    new_city: 'Yeni Şehir',
    edit_city: 'Şehri Düzenle',
    name: 'Şehir Adı',
    // slug labels (filtre / hücre)
    nicosia: 'Lefkoşa',
    famagusta: 'Gazimağusa',
    iskele: 'İskele',
    kyrenia: 'Girne',
    larnaca: 'Larnaka',
    lefke: 'Lefke',
    limassol: 'Limasol',
    morphou: 'Güzelyurt',
    paphos: 'Baf',
    turkey: 'Türkiye',
  },
  event_types: {
    1: 'Standart',
    2: 'Alan Planı',
    3: 'Koltuklu',
  },
  date_types: {
    oneoff: 'Tek Tarih',
    session: 'Seanslı',
  },
  stocks: {
    title_event: 'Seans Listesi',
    desc_event: 'Bu liste seçilen etkinlik için tarih/saat sırasına göre seansları gösterir.',
    title_default: 'Seans Listesi',
    desc_default: 'Bu liste tarih/saat sırasına göre son 100 seansı gösterir.',
    no_permission: 'Bu sayfayı görüntülemek için yetkiniz bulunmamaktadır.',
  },
  payments: {
    title: 'Ödeme İşlem Detayı',
    section_summary: 'Özet',
    section_card: 'Kart / İşlem',
    section_refund: 'İade durumu',
    status: 'Durum',
    status_awaiting: 'Bekliyor',
    status_confirmed: 'Onaylandı',
    status_failed: 'Başarısız',
    status_refunded: 'İade Edildi',
    status_unknown: 'Bilinmiyor',
    payment_id: 'Ödeme ID',
    payment_amount: 'Ödeme Tutarı',
    payment_date: 'Ödeme Tarihi',
    sale: 'Satış',
    event: 'Etkinlik',
    card_holder: 'Kart Sahibi',
    card_number: 'Kart Numarası',
    order_id: 'Sipariş ID',
    transaction_id: 'İşlem ID',
    x_id: 'X ID',
    refunded_amount: 'İade Edilen Tutar',
    refund_note: 'İade Notu',
    pending_refund: 'Bekleyen İade (Ertesi Gün)',
    refunded_at: 'İade Tarihi',
    error_message: 'Hata Mesajı',
    information: 'Bilgi',
    refund_failed_warning: 'İade başarısız',
    retry_limit_exceeded: ' (deneme limiti aşıldı)',
    will_retry: ' (tekrar denenecek)',
    unknown_error: 'Bilinmeyen hata',
    refund_action_title: 'İade işlemi',
    refund_action_desc:
      'Garanti TEST/PROD üzerinden kart ödemesini iade eder. İade edilebilir tutar:',
    make_refund: 'İade yap',
    dialog_title: 'Ödeme iadesi',
    amount_based: 'Tutar bazlı',
    product_based: 'Ürün bazlı',
    refund_amount_label: 'İade tutarı (TL)',
    max_label: 'Maksimum:',
    same_day_garanti_warning:
      'Bu ödeme bugün yapıldığı için Garanti yalnızca tam iade kabul eder. Sadece bir ürünü iade etmek için işlemin ertesi günü tekrar deneyin.',
    loading_products: 'Ürünler yükleniyor...',
    no_refundable_products: 'Bu satışta iade edilebilir ürün bulunamadı.',
    col_product: 'Ürün',
    col_unit: 'Birim',
    col_count: 'Adet',
    selected_total: 'Seçilen tahmini tutar:',
    same_day_note_footer:
      'Not: Garanti aynı gün kısmi iadeye izin vermez; kısmi/ürün bazlı iade ertesi gün yapılabilir.',
    cancel: 'Vazgeç',
    schedule_next_day: 'Ertesi güne planla (otomatik iade)',
    confirm_refund: 'İadeyi onayla',
    processing: 'İşleniyor...',
    refund_logs_title: 'İade logları',
  },
  notifications: {
    title: 'Bildirimler',
    desc: 'Eski mobil (Gişe Expo), yeni mobil ve web ayrı kanallar.',
    tab_legacy_mobile: 'Eski mobil uygulama',
    tab_new_mobile: 'Yeni mobil uygulama',
    tab_web: 'Web Bildirimi',
    legacy_token_info: 'Eski Gişe Expo token:',
    legacy_token_desc:
      'Firebase `users.token` → legacy_push_tokens. Sadece konu + açıklama. İstersen token’lı kullanıcı seç.',
    new_token_info: 'Yeni mobil token:',
    new_token_desc:
      'Nest `push_tokens` (yeni app register). Sadece konu + açıklama. İstersen token’lı kullanıcı seç.',
    web_live_ws: 'Canlı WS:',
    web_logged_in: 'Login olmuş:',
    web_os_push: 'OS push:',
    web_live_desc: 'Canlı = sitede açık sekme + WebSocket. Her 3 sn yenilenir.',
    target_mobile: 'Hedef (mobil)',
    target_web: 'Hedef kitle (web)',
    target_all_tokens: 'Tüm token’lara',
    target_select_users_token: 'Kullanıcı seç (token’lı)',
    target_live_only: 'Sadece canlı (WS)',
    target_all_logged_in: 'Login olmuş herkese',
    target_by_role: 'Role göre',
    target_select_users: 'Kullanıcı seç',
    role_label: 'Rol',
    searching: 'Aranıyor...',
    min_chars: 'En az 2 karakter yazın',
    no_user_with_token: 'Token’ı olan kullanıcı yok',
    no_user_found: 'Kullanıcı bulunamadı',
    search_user_with_token: 'Token’ı olan kullanıcı ara',
    search_user: 'Kullanıcı ara',
    search_placeholder: 'E-posta, ad, soyad...',
    mobile_token_help: 'Sadece bu app’te push token’ı olanlar listelenir',
    web_users_help: 'Seçilen kullanıcılara gider',
    subject: 'Konu',
    description: 'Açıklama',
    event_optional: 'Etkinlik (opsiyonel)',
    event_optional_help: 'Tıklanınca etkinlik sayfası açılır',
    send_legacy_mobile: 'Eski mobile gönder',
    send_new_mobile: 'Yeni mobile gönder',
    send_web: 'Web’e Gönder',
    confirm_send_web: '"%{title}" web bildirimi → %{target}. Devam?',
    confirm_send_mobile: '"%{title}" %{app} → %{who}. Devam?',
    web_sent_success: 'Web gönderildi · hedef %{targets} · canlı %{live} · OS push %{push}',
    mobile_sent_success: '%{app} mobil gönderildi (%{sent} cihaz)',
    sent_failed: 'Gönderim başarısız',
  },
  users: {
    title: 'Kullanıcılar',
    desc: 'E-posta, telefon numarası veya isme göre ara (tüm kullanıcılar taranır).',
    search_label: 'Arama',
    search_placeholder: 'E-posta, telefon, ad veya soyad…',
    load_error: 'Kullanıcılar yüklenemedi: %{error}',
    results_count: '“%{query}” için %{count} sonuç bulundu',
    latest_count: 'Son %{count} kullanıcı gösteriliyor (herkesi bulmak için aramayı kullanın)',
    permissions_loading: 'Kullanıcı Yetkileri Yükleniyor...',
    personal_info: 'Kişisel Bilgiler',
    membership_date: 'Üyelik Tarihi',
    dob: 'Doğum Tarihi',
    newsletter: 'Bülten Aboneliği',
    is_verified: 'Onaylı Kullanıcı',
    verification_code: 'Doğrulama Kodu',
    verification_code_help:
      'Bu kodu değiştirdiğinizde kullanıcıya yeni bir doğrulama e-postası gönderilir.',
    new_password: 'Yeni Şifre',
    new_password_help: 'Mevcut şifreyi korumak için boş bırakın.',
    role_section: 'Rol',
    role_label: 'Rol',
    no_role: 'Rol yok',
    org_company_label: 'Organizasyon Şirketi',
    venue_label: 'Mekan',
    email_unique_help:
      'Benzersiz olmalıdır. Kullanıcı kaydettikten sonra bu e-posta ile giriş yapacaktır.',
    view_sales: 'Satışları Gör',
    default_role: 'Kullanıcı',
    roles: {
      admin: 'Admin',
      organisationCompanyManager: 'Organizör Yöneticisi',
      venueManager: 'Mekan Yöneticisi',
      affiliate: 'Satış Ortağı (Affiliate)',
      operator: 'Operatör',
      editor: 'Editör',
      promoter: 'Promotör',
      user: 'Kullanıcı',
    },
  },
  promoters: {
    title: 'Organizörler / Promotörler',
    user: 'Kullanıcı',
    mobile: 'Telefon',
    belongs_to: 'Ait Olduğu Kurum',
    created_on: 'Oluşturulma Tarihi',
    filter_org: 'Org. Şirketi Filtresi',
    filter_venue: 'Mekan Filtresi',
    company_name: 'Şirket Adı',
    venue_name: 'Mekan Adı',
    user_selection: 'Kullanıcı Seçimi',
    details: 'Detaylar',
    promoter_type: 'Promotör Türü',
    type_org: 'Organizasyon Şirketi',
    type_venue: 'Mekan',
    please_select: 'Lütfen Seçiniz',
    org_company: 'Organizasyon Şirketi',
    venue: 'Mekan',
    notes: 'Notlar',
    notes_placeholder: 'Promotör ile ilgili notlarınızı buraya yazabilirsiniz..',
  },
  saleAgents: {
    title: 'Satış Temsilcileri',
    title_applications: 'Satış Temsilcisi Başvuruları',
    tab_list: 'Satış Temsilcileri',
    tab_applications: 'Başvurular',
    new_agent: 'Yeni Satış Temsilcisi',
    edit_agent: 'Satış Temsilcisini Düzenle',
    name: 'İsim',
    user: 'Kullanıcı',
    email: 'E-posta',
    mobile: 'Telefon',
    notes: 'Notlar',
    created: 'Oluşturulma Tarihi',
    user_section: 'Kullanıcı',
    details_section: 'Detaylar',
    search_placeholder: 'İsim veya not ara…',
    partner_section: 'Partner Portal Atamaları',
    key_website: 'Web Site / Uygulama Linki',
    key_affiliate: 'Affiliate Kodu',
    key_events: 'Etkinlikler',
    key_venues: 'Mekanlar',
    key_orgs: 'Organizasyon Şirketleri',
    key_address: 'Fiziksel Adres',
    website_url: 'Web site veya uygulama linki',
    website_url_help:
      'Doldurulursa partner feed endpoint’i açılır (sitelerine entegre edebilirler).',
    feed_title: 'Site entegrasyon endpoint’i',
    feed_help: 'Bu URL’den partner etkinliklerini JSON olarak çekebilirsiniz.',
    copy_feed: 'Kopyala',
    affiliate_code: 'Affiliate Kodu',
    events: 'Etkinlikler',
    venues: 'Mekanlar',
    orgs: 'Organizasyon Şirketleri',
    has_physical_address: 'Fiziksel adresi var mı?',
    physical_address: 'Konum / Açık Adres',
    physical_address_help: 'Adres veya konum bilgisini girin',
  },
  venues: {
    title: 'Mekanlar',
    title_applications: 'Mekan Başvuruları',
    tab_list: 'Mekanlar',
    tab_applications: 'Başvurular',
    new_venue: 'Yeni Mekan',
    edit_venue: 'Mekanı Düzenle',
    basic_info: 'Temel Bilgiler',
    url_slug: 'URL Bağlantısı (Slug)',
    media: 'Medya',
    logo: 'Logo',
    banner: 'Kapak Görseli',
    venue_layout: 'Mekan Yerleşimi',
    youtube: 'Youtube',
    youtube_help: 'Lütfen sadece video ID’sini (URL’deki ?v= sonrası kütüğü) giriniz.',
    contact: 'İletişim',
    about: 'Mekan Hakkında',
    address_info: 'Adres Bilgileri',
    city: 'Şehir',
    address: 'Açık Adres',
    legal: 'Yasal Bilgiler',
    company_type: 'Şirket Türü',
    legal_entity: 'Yasal Şirket Unvanı',
    legal_tax_name: 'Vergi Dairesi Unvanı',
    tax_document: 'Vergi Levhası',
    financial: 'Finansal Bilgiler',
    bank_account_name: 'Banka Hesap Sahibi',
    bank_name: 'Banka Adı',
    bank_iban: 'IBAN Numarası',
    seo: 'SEO Ayarları',
    managers: 'Yöneticiler',
    feature_button: 'Öne Çıkar',
    square_img_hint: 'Kare oranlı görsel yüklenmelidir (birebir ölçü).',
    landscape_img_hint: 'Yatay oranlı görsel yüklenmelidir (16:9 önerilir).',
    search_placeholder: 'Ad, slug, telefon, e-posta veya adres ara…',
  },
  organisationCompanies: {
    title: 'Organizasyon Şirketleri',
    title_applications: 'Organizasyon Başvuruları',
    tab_list: 'Organizasyon Şirketleri',
    tab_applications: 'Başvurular',
    new_company: 'Yeni Organizasyon Şirketi',
    edit_company: 'Organizasyon Şirketini Düzenle',
    company_details: 'Şirket Detayları',
    about_company: 'Şirket Hakkında',
    name: 'Şirket Adı',
    phone: 'Telefon',
    email: 'E-posta',
    managers: 'Yöneticiler',
    search_placeholder: 'Ad, slug, telefon, e-posta veya adres ara…',
  },
  layouts: {
    title: 'Mekan Yerleşimleri / Düzenler',
    new_layout: 'Yeni Yerleşim Planı',
    edit_layout: 'Yerleşim Planını Düzenle',
    name: 'Plan Adı',
    venue: 'Mekan',
    type: 'Tür',
    seat_plan: 'Koltuklu Oturma Planı',
    area_layout: 'Alan / Ayakta Düzen',
    firebase_temp_note: 'Geçici: Aynı id ile Firebase layouts üzerine yazar',
    no_data_error: 'Bu layout için kayıtlı oturma planı verisi yok.',
  },
  seating: {
    add_seat: 'Koltuk Ekle',
    add_bg: 'Arka Plan Ekle (Görsel)',
    remove_bg: 'Arka Planı Kaldır (Görsel)',
    add_area_rect: 'Alan Ekle (Dikdörtgen)',
    add_area_circle: 'Alan Ekle (Daire)',
    select_seats_assign: 'Ürün atamak için koltuk seçin',
    select_area_assign: 'Ürün atamak için bir alan seçin',
    create_seats: 'İşlemleri görmek için koltuk oluşturun',
    create_areas: 'İşlemleri görmek için alan oluşturun',
    selected: 'Seçili:',
    seats: 'koltuk',
    areas: 'alan',
    area: 'alan',
    create_actions: 'Oluşturma İşlemleri:',
    delete: 'Sil',
    rename_seat_id: 'Koltuk ID Yeniden Adlandır',
    assign_tickets: 'Bilet Ata:',
    ticket: 'Bilet',
    assign: 'Ata',
    remove: 'Kaldır',
    clone: 'Kopyala',
    edit_size: 'Boyutu Düzenle',
    rename: 'Yeniden Adlandır',
    bg_color: 'Arka Plan Rengi',
    fg_color: 'Yazı Rengi',
    selectable: 'Seçilebilir',
    view_products: 'Ürünleri Gör:',
    select_one_area_view: 'Ürünleri görmek için yalnızca bir alan seçin',
    select_one_area_assign: 'Ürün atamak için yalnızca bir alan seçin',
    no_products: 'Henüz ürün atanmadı.',
    assign_products: 'Ürün Ata:',
    products: 'Ürünler',
    product: 'Ürün',
    stats: 'İstatistikler',
    total_seats: 'Toplam Koltuk:',
    total_areas: 'Toplam Alan:',
    assigned_seats: 'Atanmış Koltuk:',
    assigned_areas: 'Atanmış Alan:',
    unassigned_seats: 'Atanmamış Koltuk:',
    unassigned_areas: 'Atanmamış Alan:',
    assigned_products: 'Atanmış Ürünler/Biletler:',
    prompt_area_width: 'Alan genişliğini girin',
    prompt_area_height: 'Alan yüksekliğini girin',
    prompt_image_url: 'Görsel URL’sini girin',
    prompt_clone_label: 'Kopyalanan alan için etiket girin:',
    label_exists: 'Bu etiket zaten var; benzersiz olmalı',
    prompt_new_width: 'Yeni genişlik:',
    prompt_new_height: 'Yeni yükseklik:',
    prompt_new_radius: 'Yeni yarıçap:',
    prompt_seat_id: 'Koltuk için yeni ID girin:',
    id_unique: 'ID benzersiz olmalı.',
    prompt_color: 'Yeni renk girin:',
    select_product_first: 'Önce bir ürün seçin. Yoksa yeni ürün ekleyin.',
  },
  salePoints: {
    title: 'Satış Noktaları',
    new_salepoint: 'Yeni Satış Noktası',
    edit_salepoint: 'Satış Noktasını Düzenle',
    name: 'Satış Noktası Adı',
    telephone: 'Telefon',
    description: 'Açıklama',
    city: 'Şehir',
    address: 'Adres',
    longitude: 'Boylam (Longitude)',
    latitude: 'Enlem (Latitude)',
    photo_logo: 'Logo / Fotoğraf',
    payment_methods: 'Ödeme Yöntemleri',
    active_filter: 'Aktiflik Filtresi',
    show_on_website: 'Satış noktasını web sitesinde göster',
    save_notice: 'Değişikliklerin geçerli olması için kaydetmeniz gerekir.',
    method_cc: 'Kredi Kartı',
    method_cash: 'Nakit',
    method_btc: 'Bitcoin',
    method_transfer: 'Havale / EFT',
  },
  categories: {
    title: 'Kategoriler',
    new_category: 'Yeni Kategori',
    edit_category: 'Kategoriyi Düzenle',
    name: 'Kategori Adı',
    active: 'Aktif mi?',
    order: 'Sıra',
    active_help: 'Bu kategoriyi devre dışı bırakmak istiyorsanız bu seçeneğin işaretini kaldırın.',
    order_help: 'Kategorinin sıralamasını belirlemek için bir sayı giriniz.',
    yes: 'Evet',
    no: 'Hayır',
  },
  subcategories: {
    title: 'Alt Kategoriler',
    new_subcategory: 'Yeni Alt Kategori',
    edit_subcategory: 'Alt Kategoriyi Düzenle',
    name: 'Alt Kategori Adı',
    category: 'Üst Kategori',
  },
  venueCategories: {
    title: 'Mekan Kategorileri',
    new_category: 'Yeni Mekan Kategorisi',
    edit_category: 'Mekan Kategorisini Düzenle',
    name: 'Kategori Adı',
  },
  news: {
    title: 'Haberler & Duyurular',
    new_news: 'Yeni Haber',
    edit_news: 'Haberi Düzenle',
    news_title: 'Başlık',
    subtitle: 'Alt Başlık',
    content: 'İçerik',
    date: 'Tarih',
    banner: 'Haber Görseli',
    created: 'Oluşturulma Tarihi',
    updated: 'Son Güncelleme',
  },
  pages: {
    title: 'Sabit Sayfalar',
    edit_page: 'Sayfayı Düzenle',
    page_title: 'Sayfa Başlığı',
    content: 'İçerik',
  },
  heros: {
    title: 'Ana Sayfa Özel Etkinlik Görseli (Hero)',
    bg_image: 'Hero Arka Plan Görseli',
    banner_crop_hint: 'Home hero ölçüsü 1920×504. Kaydetmeden önce kırpın.',
    banner_crop_title: 'Görseli Kırp (1920×504)',
    banner_crop_desc:
      'Kırpma alanı home hero oranında kilitli. Alanı sürükleyip boyutunu ayarlayabilirsiniz.',
    featured_image: "Özel görsel (opsiyonel — yoksa etkinlik banner'ı)",
    featured_crop_hint: 'Hero kart ölçüsü 275×344. Kaydetmeden önce kırpın.',
    featured_crop_title: 'Görseli Kırp (275×344)',
    featured_crop_desc:
      'Kırpma alanı hero kart oranında kilitli. Alanı sürükleyip boyutunu ayarlayabilirsiniz.',
    record: 'Kayıt',
    last_updated: 'Son Güncelleme',
    empty_msg: 'Hero kaydı yok. "Oluştur" ile ID: home olarak oluşturun.',
  },
  homeSections: {
    title: 'Ana Sayfa Bölümleri',
    new_section: 'Yeni Ana Sayfa Bölümü',
    edit_section: 'Ana Sayfa Bölümünü Düzenle',
    main_details: 'Temel Bilgiler',
    content: 'İçerik',
    order: 'Sıra',
    title_tr: 'Başlık (TR)',
    title_en: 'Başlık (EN)',
    is_featured: 'Öne Çıkanlar bölüm modeli? (özel görsel + fiyat butonu)',
    featured_help:
      'Öne Çıkanlar: Kart butonu "Satın Al" yerine aktif ürünlerin en düşük fiyatını gösterir.',
    fetch_upcoming_venue: 'Bu mekanın yaklaşan etkinliklerini getir? (manuel seçim yapmadan)',
    fetch_upcoming_category: 'Kategorinin yaklaşan etkinliklerini göster?',
  },
  featureds: {
    title: 'Öne Çıkan Liste Ayarları',
    new_featured: 'Yeni Öne Çıkan Kayıt',
    edit_featured: 'Öne Çıkan Kaydı Düzenle',
    venues: 'Mekanlar',
  },
  groupEvents: {
    title: 'Grup Etkinlikleri / Festival Serileri',
    new_group: 'Yeni Grup Etkinliği',
    edit_group: 'Grup Etkinliğini Düzenle',
    basic_details: 'Temel Detaylar',
    name: 'Grup Adı',
    start_date: 'Başlangıç Tarihi',
    end_date: 'Bitiş Tarihi',
    description: 'Açıklama',
    multiple_venues: 'Bu grup etkinliği birden fazla mekanda mı gerçekleşiyor?',
    multiple_venues_help: 'Sadece birden fazla mekan varsa aktif edin.',
    num_events: 'Etkinlik Sayısı',
    homepage_categories: 'Ana Sayfa Gösterim Kategorileri',
    homepage_categories_help:
      'Bu grup etkinliğinin web sitesi ve mobil uygulama ana sayfasında gösterileceği kategoriler.',
    select_categories: 'Kategorileri Seçin',
    video_id: 'Video ID (YouTube ID)',
    select_events: 'Etkinlikleri Seçin',
    loading_upcoming: 'Yaklaşan etkinlikler yükleniyor…',
    load_error: 'Etkinlikler yüklenemedi: %{error}. API’nin çalıştığını kontrol edin.',
    no_upcoming: 'Yaklaşan aktif etkinlik bulunamadı. Önce etkinlik oluşturun veya yayınlayın.',
  },
  event_status: {
    cancelled: 'İptal',
    pending: 'Beklemede',
    upcoming: 'Yaklaşan',
    active: 'Şu an devam ediyor!',
    ended: 'Yakın zamanda bitti',
    ended_short: 'Bitti',
    unknown: 'Bilinmiyor',
  },
  affiliates: {
    title: 'Satış Ortakları (Affiliates)',
    new_affiliate: 'Yeni Satış Ortağı',
    edit_affiliate: 'Satış Ortağını Düzenle',
    details: 'Satış Ortağı Detayları',
    name: 'İsim / Şirket Adı',
    code: 'Ortaklık Kodu (AF Code)',
    search_code: 'AF Kodu Ara',
    created: 'Oluşturulma Tarihi',
    search_placeholder: 'İsim veya AF kodu ara…',
    pull_firebase: 'Firebase’den Çek (Postgres)',
    pulling: 'Çekiliyor…',
    pull_confirm: 'Firebase’deki tüm affiliate kayıtları Postgres’e aktarılsın mı?',
    pull_ok: 'Pull OK: {{affiliates}} affiliate, {{users}} kullanıcı',
    pull_partial: '{{count}} kayıtta hata (detay konsolda)',
    pull_error: 'Pull hata: {{message}}',
  },
  systemParameters: {
    title: 'Sistem Parametreleri',
    edit_title: 'Sistem Parametrelerini Düzenle',
    system_settings: 'Sistem Ayarları',
    admin_phone: 'Admin Telefon Numarası',
    variables: 'Değişkenler',
    default_service_fee: 'Varsayılan Hizmet Ücreti',
    default_commission_fee: 'Varsayılan Komisyon Ücreti',
  },
  appVersionConfigs: {
    title: 'Sürüm Kontrolü',
    platform: 'Platform',
    latest_version: 'En Güncel Sürüm',
    minimum_version: 'Minimum Sürüm',
    force_update: 'Zorunlu Güncelleme',
    maintenance: 'Bakım Modu',
    store_url: 'Mağaza Bağlantısı (URL)',
    maintenance_message: 'Bakım Mesajı',
    release_notes: 'Sürüm Notları (Her satır bir madde)',
    latest_help: 'Örn: 2.4.0 — mağazadaki en güncel sürüm',
    min_help: 'Bu sürümün altındakiler uygulamayı kullanamaz',
    force_help: 'Açıksa ve kullanıcı en güncel sürümün altındaysa zorunlu güncelleme gösterilir',
  },
  deleteUserRequests: {
    title: 'Hesap Silme Talepleri',
    search_placeholder: 'E-posta, isim veya telefon',
    name: 'Ad Soyad',
    email: 'E-posta',
    mobile: 'Telefon',
    reason: 'Silme Nedeni',
    requested_at: 'Talep Tarihi',
    open_user: 'Kullanıcıyı Aç',
    opening: 'Açılıyor…',
    open_ok: 'Kullanıcı açıldı (DB + Firebase)',
    open_ok_no_firebase_doc: 'Kullanıcı açıldı (Firestore dokümanı yoktu)',
    open_partial: 'DB açıldı; Firebase yazılamadı: %{reason}',
    open_fail: 'Kullanıcı açılamadı',
    reasons: {
      another_account: 'Başka bir hesabım var',
      privacy_concerns: 'Gizlilik kaygılarım var',
      unused_account: 'Kullanılmayan/aktif olmayan hesap',
      other_reason: 'Diğer bir sebebim var',
    },
  },
  affiliateForm: {
    title: 'Affiliate Başvuruları',
    edit_title: 'Başvuruyu İncele / Düzenle',
    app_name: 'Başvuru Sahibi Adı',
    app_surname: 'Başvuru Sahibi Soyadı',
    user: 'Kullanıcı',
    user_mobile: 'Kullanıcı Telefonu',
    checked: 'İncelendi mi?',
    actions: 'İşlemler',
    notes: 'Notlar',
    details: 'Başvuru Detayları',
  },
  scripts: {
    title: 'Kod ve Script Yönetimi',
    new_script: 'Yeni Script Ekle',
    edit_script: 'Scripti Düzenle',
    name: 'Script Adı',
    order: 'Sıra',
    active: 'Aktif mi?',
    content: 'Script Kodu',
    helper_text:
      '<script> etiketleri dahil tüm script kodunu buraya yapıştırabilirsiniz. Tüm nitelikler (ör. data-key) korunacaktır.',
  },
  eventCreationApplications: {
    title: 'Başvurular',
    title_venue: 'Mekan Başvuruları',
    title_org: 'Organizasyon Başvuruları',
    title_sales: 'Satış Temsilcisi / Ortak Başvuruları',
    application_detail: 'Başvuru Detayı',
    review_application: 'Başvuruyu İncele / Düzenle',
    approved: 'Onaylandı',
    pending: 'Beklemede',
    organiser: 'Organizatör',
    venue: 'Mekan',
    sales_agent: 'Satış Ortağı',
    summary: 'Özet',
    company_info: 'Şirket Bilgileri',
    basic_info: 'Temel Bilgiler',
    contact: 'İletişim',
    about_venue: 'Mekan Hakkında',
    about_company: 'Şirket Hakkında',
    media: 'Medya',
    address: 'Adres',
    legal: 'Yasal Bilgiler',
    financial: 'Finansal Bilgiler',
    seo: 'SEO Ayarları',
    review_add_note: 'İncele / Not Ekle',
    categories: 'Kategoriler',
    amenities: 'Mekan Olanakları',
    actions: 'İşlemler',
    application_type: 'Başvuru Tipi',
    details: 'Detaylar',
  },
  'resources.users.fields.name': 'Ad',
  'resources.users.fields.surname': 'Soyad',
  'resources.users.fields.email': 'E-posta',
  'resources.users.fields.mobile': 'Telefon',
  'resources.users.fields.crole': 'Rol',
  'resources.users.fields.createdate': 'Kayıt Tarihi',
  'resources.users.fields.gender': 'Cinsiyet',
  'resources.users.fields.country': 'Ülke',
  'resources.users.fields.city': 'Şehir',
  'resources.users.fields.dob': 'Doğum Tarihi',
  'resources.users.fields.newsletter': 'Bülten Aboneliği',
  'resources.users.fields.isVerified': 'Onaylı',
  'resources.users.fields.verificationCode': 'Doğrulama Kodu',
  'resources.promoters.fields.user': 'Kullanıcı',
  'resources.promoters.fields.mobile': 'Telefon',
  'resources.promoters.fields.organisationCompanies': 'Organizasyon Şirketi',
  'resources.promoters.fields.venues': 'Mekan',
  'resources.promoters.fields.createdate': 'Oluşturulma Tarihi',
  'resources.saleAgents.fields.name': 'Satış Temsilcisi Adı',
  'resources.saleAgents.fields.user': 'Kullanıcı',
  'resources.saleAgents.fields.notes': 'Notlar',
  'resources.saleAgents.fields.createdate': 'Oluşturulma Tarihi',
  'resources.venues.fields.name': 'Mekan Adı',
  'resources.venues.fields.categories': 'Kategoriler',
  'resources.venues.fields.managers': 'Yöneticiler',
  'resources.venues.fields.city': 'Şehir',
  'resources.organisationCompanies.fields.name': 'Şirket Adı',
  'resources.organisationCompanies.fields.managers': 'Yöneticiler',
  'resources.layouts.fields.name': 'Plan Adı',
  'resources.layouts.fields.venue': 'Mekan',
  'resources.layouts.fields.layoutType': 'Plan Türü',
  'resources.salePoints.fields.name': 'Satış Noktası Adı',
  'resources.salePoints.fields.city': 'Şehir',
  'resources.salePoints.fields.isActive': 'Aktif mi?',
  'resources.salePoints.fields.managers': 'Yöneticiler',
  'resources.events-v2.fields.id': 'ID',
  'resources.events-v2.fields.name': 'Etkinlik Adı',
  'resources.events-v2.fields.type': 'Tür',
  'resources.events-v2.fields.venue': 'Mekan',
  'resources.events-v2.fields.city': 'Şehir',
  'resources.events-v2.fields.category': 'Kategori',
  'resources.events-v2.fields.startdate': 'Başlangıç Tarihi',
  'resources.events-v2.fields.enddate': 'Bitiş Tarihi',
  'resources.events-v2.fields.isVerified': 'Onaylı / Yayında',
  'resources.events-v2.fields.totalRevenue': 'Toplam Gelir',
  'resources.events-v2.fields.status': 'Durum',

  'resources.sales.fields.id': 'ID',
  'resources.sales.fields.user.name': 'Kullanıcı',
  'resources.sales.fields.userName': 'Kullanıcı',
  'resources.sales.fields.createdate': 'Satış Tarihi',
  'resources.sales.fields.event.name': 'Etkinlik Adı',
  'resources.sales.fields.eventName': 'Etkinlik Adı',
  'resources.sales.fields.userMobile': 'Kullanıcı Telefonu',
  'resources.sales.fields.channel': 'Kanal',
  'resources.sales.fields.soldBy': 'Satan Kişi/Nokta',
  'resources.sales.fields.payment': 'Ödeme (₺)',
  'resources.sales.fields.paymentType': 'Ödeme Türü',
  'resources.sales.fields.oid': 'Sipariş No',
  'resources.sales.fields.productsCount': 'Ürün Adedi',
  'resources.sales.fields.product': 'Ürün',
  'resources.sales.fields.coupon': 'Kupon',
  'resources.sales.fields.status': 'Durum',
  'resources.sales.fields.actions': 'İade Talebi / Durum',
  'resources.sales.fields.isNewRegistrationSale': 'Yeni Kayıt (Son 7 Gün)',
  'resources.sales.fields.pendingRefund': 'İade Durumu',
  'resources.sales.fields.deleteButton': 'Sil',

  'resources.tickets.fields.id': 'ID',
  'resources.tickets.fields.pnr': 'PNR',
  'resources.tickets.fields.print': 'Bilet Yazdır',
  'resources.tickets.fields.channel': 'Satış Kanalı',
  'resources.tickets.fields.userName': 'Kullanıcı',
  'resources.tickets.fields.eventName': 'Etkinlik Adı',
  'resources.tickets.fields.created': 'Satış Tarihi',
  'resources.tickets.fields.product': 'Ürün',
  'resources.tickets.fields.productKey': 'Ürün Anahtarı',
  'resources.tickets.fields.isUsed': 'Kullanıldı mı?',
  'resources.tickets.fields.refund': 'İade',
  menu: {
    dashboard: 'Kontrol Paneli',
    events_v2: 'Etkinlikler (v2)',
    new_event: 'Yeni Etkinlik',
    upcoming_events: 'Yaklaşan Etkinlikler',
    past_events: 'Geçmiş Etkinlikler',
    group_events: 'Grup Etkinlikleri',
    notifications: 'Bildirimler',
    sales: 'Satışlar',
    tickets: 'Biletler',
    refund_requests: 'İade Talepleri',
    people: 'Kişiler ve Kullanıcılar',
    users: 'Kullanıcılar',
    affiliates: 'Satış Ortakları (Affiliate)',
    sale_agents: 'Satış Temsilcileri',
    promoters: 'Organizörler / Promotörler',
    affiliate_form: 'Affiliate Başvuruları',
    delete_requests: 'Hesap Silme Talepleri',
    places: 'Mekanlar ve Yerler',
    venues: 'Mekanlar',
    layouts: 'Oturma Planları',
    layouts_v2: 'Layouts v2',
    org_companies: 'Organizasyon Şirketleri',
    sale_points: 'Satış Noktaları',
    definitions: 'Tanımlamalar',
    featured: 'Öne Çıkanlar',
    categories: 'Kategoriler',
    subcategories: 'Alt Kategoriler',
    venue_categories: 'Mekan Kategorileri',
    cities: 'Şehirler',
    website: 'Web Sitesi Yönetimi',
    home_sections: 'Ana Sayfa Bölümleri',
    hero_banner: 'Ana Sayfa Özel Etkinlik Hero',
    pages: 'Sayfalar',
    news: 'Haberler',
    scripts: 'Kod ve Scriptler',
    accountancy: 'Muhasebe',
    accountancy_items: 'Muhasebe Kalemleri',
    mobile_app: 'Mobil Uygulama',
    app_version: 'Sürüm Kontrolü',
    super_admin: 'Sistem Yönetimi',
    deepl_settings: 'DeepL Ayarları',
    parameters: 'Sistem Parametreleri',
    v1_archive: 'Etkinlik V1 Arşivi',
    session_events_archive: 'Session Etkinlik Arşivi',
    advertising: 'Reklam',
    ad_packages: 'Reklam Paketleri',
    ad_applications: 'Reklam Başvuruları',
    popup_ads: 'Pop-up Reklamlar',
    content: 'İçerik',
  },
  adPackages: {
    title: 'Reklam Paketleri',
    create_title: 'Yeni Paket',
    edit_title: 'Paket Düzenle',
    form_heading: 'Reklam Paketi',
    form_subheading: 'Önce tipi seç veya oluştur, sonra paket detaylarını doldur.',
    name: 'Paket Adı',
    type: 'Tip',
    type_section_title: 'Paket Tipi',
    type_section_desc: 'Bu paket için yalnızca bir tip seç (çoklu seçim yok).',
    existing_types: 'Mevcut tipler',
    type_placeholder: 'Tip seç…',
    type_single_hint: 'Her paket için tek tip.',
    new_type: 'Yeni tip oluştur',
    new_type_placeholder: 'örn. story, sidebar, newsletter…',
    add_type: 'Tip ekle',
    selected_type: 'Seçili: %{name}',
    type_required: 'Lütfen bir paket tipi seç veya oluştur.',
    type_helper: 'Mevcut bir tip seçin veya yeni tip yazıp Enter’a basarak oluşturun.',
    create_type: 'Tip oluştur: "%{item}"',
    details_section_title: 'Paket Detayları',
    details_section_desc: 'Ad, fiyat ve görünürlük bilgileri.',
    description: 'Açıklama',
    price: 'Fiyat',
    currency: 'Para Birimi',
    duration_days: 'Süre (gün)',
    order: 'Sıra',
    is_active: 'Aktif?',
    types: {
      meta: 'Meta Ads',
      site: 'Site Banner',
      popup: 'Popup',
      featured: 'Öne Çıkan',
      homepage: 'Ana Sayfa',
    },
  },
  adApplications: {
    title: 'Reklam Başvuruları',
    detail: 'Reklam Başvurusu',
    company: 'Şirket',
    package: 'Paket',
    package_type: 'Paket Tipi',
    preferred_start: 'Tercih Edilen Başlangıç',
    budget: 'Bütçe',
    message: 'Mesaj',
    review: 'Başvuruyu İncele',
  },
  'resources.adPackages.name': 'Reklam Paketi |||| Reklam Paketleri',
  'resources.adApplications.name': 'Reklam Başvurusu |||| Reklam Başvuruları',
  'resources.popupAds.name': 'Pop-up Reklam |||| Pop-up Reklamlar',
  popupAds: {
    title: 'Pop-up Reklamlar',
    create_title: 'Yeni Pop-up',
    edit_title: 'Pop-up Düzenle',
    form_heading: 'Pop-up Reklam',
    form_subheading:
      'Banner, başlık, etkinlikler ve hangi sayfalarda çıkacağını ayarlayın. Önizleme canlı güncellenir.',
    name: 'Dahili Ad',
    name_helper: 'Sadece panel listesinde görünür',
    order: 'Sıra',
    is_active: 'Aktif?',
    dismiss_hours: 'Kapatınca gizlenme (saat)',
    dismiss_helper: 'Kullanıcı X’e basınca bu kadar saat tekrar gösterme',
    banner: 'Üst Banner Görseli',
    banner_hint: 'Önerilen ölçü 720×200. Kaydetmeden önce kırpın.',
    title_field: 'Başlık',
    title_color: 'Başlık Rengi',
    subtitle: 'Alt Başlık',
    subtitle_color: 'Alt Başlık Rengi',
    footer_note: 'Alt Not (ince yazı)',
    pages: 'Gösterilecek Sayfalar',
    pages_helper: '“Tüm sayfalar” seçilirse site genelinde çıkar',
    events: 'Etkinlikler (Slider)',
    event: 'Etkinlik',
    preview: 'Önizleme',
    preview_hint: 'Webde kartlar sizin etkinlik kart tasarımınızla slider olarak görünür.',
    preview_title_placeholder: 'Başlık buraya gelecek',
    preview_subtitle_placeholder: 'Alt başlık buraya gelecek',
  },
  errors: {
    admin_only: 'Bu sayfaya yalnızca admin erişebilir.',
  },
  deepl: {
    title: 'DeepL Otomatik Çeviri',
    subtitle:
      'API anahtarını, planı ve hedef dilleri yönet. Etkinlik, grup etkinliği, kategori ve mekan içerikleri kaydedilince aktif dillere otomatik çevrilir.',
    api_key_title: 'API Anahtarı',
    api_key_desc: 'DeepL hesabından aldığın API anahtarını gir',
    api_key_placeholder: 'DeepL API Anahtarınız...',
    api_key_valid: 'API anahtarı geçerli',
    api_key_invalid: 'API anahtarı geçersiz veya girilmemiş',
    api_plan: 'API Planı',
    usage_info: 'Kullanım: %{count} / %{limit} karakter',
    save_button: 'Kaydet',
    test_button: 'Bağlantıyı Test Et',
    languages_title: 'Çeviri Dilleri',
    languages_desc: 'Hangi dillere çeviri yapılacağını seç ve yönet',
    select_language: 'Dil seç...',
    add_language: 'Ekle',
    active: 'Aktif',
    passive: 'Pasif',
    total_languages: 'Toplam %{total} dil • %{active} aktif',
    no_languages: 'Henüz dil eklenmemiş. Yukarıdan bir dil seçip otomatik çeviriyi başlat.',
    auto_translate_info: 'Otomatik çeviri aktif. Yeni ve güncellenen içerikler bu dile çevrilir.',
    auto_translate_off: 'Otomatik çeviri kapalı.',
    connection_success: 'DeepL API bağlantısı başarılı!',
    connection_failed: 'DeepL API bağlantı hatası!',
    saved_success: 'DeepL ayarları kaydedildi.',
  },
  form: {
    source_language_title: 'Kaynak Dil:',
    source_language_desc:
      'Bu dilde yazın; diğer diller DeepL ile çevrilir. Dil değiştirmek için navbar’ı kullanın.',
    source_language_locked_desc:
      'Bu kaydın kaynak dili kilitlidir (%{lang}). Çeviriler bu dil esas alınarak otomatik yapılır.',
    basic_details: 'Temel Bilgiler',
    date_details: 'Tarih Detayları',
    more_details: 'Açıklama ve Kurallar',
    visuals: 'Görseller',
    products: 'Biletler ve Stoklar',
    layout: 'Oturma Planı',
    venue_required_for_layouts:
      'Mevcut oturma planlarını görmek için Temel Bilgiler bölümünden mekan seçmelisiniz.',
    select_area_layout:
      'Seçilen mekan için bir ALAN planı seçin. Yoksa Oturma Planları modülünden oluşturun.',
    select_seating_layout:
      'Seçilen mekan için bir KOLTUK planı seçin. Yoksa Oturma Planları modülünden oluşturun.',
    no_assigned_seats_warning:
      'Kayıtlı koltuk ataması bulunamadı — base layout açıldı. Koltuklara ürün atayıp tekrar kaydedin.',
    layout_save_failed:
      'Koltuk planı kaydedilemedi: %{error}. (API 413 ise body limit deploy gerekli)',
    layout_empty_warning:
      'Layout seçili ama koltuk planı boş — Oturma Planı sekmesini açıp tekrar deneyin',
    coupons: 'Kuponlar',
    fees: 'Ücretler ve Komisyonlar',
    settings: 'Ayarlar ve Durum',
    event_description: 'Etkinlik Açıklaması',
    required_mark: '*zorunlu',
    description: 'Açıklama',
    description_tr: 'Açıklama (Türkçe)',
    description_en: 'Açıklama (İngilizce)',
    event_rules: 'Etkinlik Kuralları',
    event_rules_tr: 'Etkinlik Kuralları (Türkçe)',
    event_rules_en: 'Etkinlik Kuralları (İngilizce)',
    things_to_know: 'Bilinmesi Gerekenler',
    rule_chips: 'Kural Etiketleri',
    rule_chips_hint: 'Boş bırakılan kurallar web sitesinde görünmeyecektir.',
    age_rule: 'Yaş Sınırı Kuralı',
    show_event_on_website: 'Bu etkinliği web sitesinde göster',
    verified_event: 'Onaylı Etkinlik?',
    homepage_visibility: 'Anasayfa Görünürlüğü',
    hide_from_web_home: 'Web anasayfasında gizle',
    hide_from_web_home_hint: 'Açıksa bu etkinlik web anasayfasındaki bölümlerde gösterilmez.',
    hide_from_mobile_home: 'Mobil anasayfasında gizle',
    hide_from_mobile_home_hint: 'Açıksa bu etkinlik mobil anasayfasındaki bölümlerde gösterilmez.',
    auto_urgency_badges: 'Otomatik Aciliyet Etiketleri',
    urgency_hint: 'Kartta tek kırmızı etiket çıkar. Koşullar tutarsa öncelik: saat → bilet → gün.',
    pre_selected_types: 'Seçili Türler',
    event_name: 'Etkinlik Adı',
    unique_event_slug: 'Benzersiz Etkinlik Slug',
    organisation_company: 'Organizasyon Şirketi',
    event_badge: 'Etkinlik Rozeti',
    badge_label: 'Rozet Metni',
    label_color: 'Metin Rengi',
    background_color: 'Arka Plan Rengi',
    payment_methods: 'Ödeme Yöntemleri',
    reset_confirm: 'Formu sıfırlamak istediğinize emin misiniz?',
    category: 'Kategori',
    subcategories: 'Alt Kategoriler',
    venue: 'Mekan',
    city: 'Şehir',
    event_start_date: 'Etkinlik Başlangıç Tarihi',
    event_duration: 'Etkinlik Süresi (dakika)',
    event_end_date: 'Etkinlik Bitiş Tarihi',
    end_date_auto_calc: 'Başlangıç + Süre ile otomatik hesaplanır.',
    end_date_hint: 'Başlangıç tarihi ve süre girilince burada görünür.',
    search_placeholder: 'İsim, slug, mekan, şehir, kategori veya alt kategori ara…',
    search_user_placeholder: 'E-posta veya isim ile ara...',
    user_already_selected: 'Kullanıcı zaten seçildi',
    search_prompt: 'Aramak için e-posta veya isim giriniz',
    user_search_failed: 'Kullanıcı araması başarısız',
    loading_user: 'Kullanıcı yükleniyor…',
    change_user: 'Kullanıcıyı değiştir',
    search_results: 'Arama Sonuçları',
    no_users_found: 'Kullanıcı bulunamadı. E-posta veya ismin bir kısmını deneyin.',
    chosen_users: 'Seçilen Kullanıcı(lar)',
    visual_poster: 'Görsel / Afiş',
    visual_poster_hint: '4:5 oranında dikey görseller (1080 x 1350) yüklenmelidir.',
    poster_crop_hint:
      'Poster görselleri 4:5 (1080×1350) önerilir. Kaydetmeden önce görsel önizlemesini kontrol edin.',
    visual_design1: '1. Tasarım Görseli (Kart / Detay)',
    visual_design1_hint: 'Yatay görsel 344×194. Ana sayfa 1. tasarım kartı ve etkinlik detayı.',
    design1_crop_hint: '1. tasarım 344×194. Kaydetmeden önce kırpın.',
    design1_crop_title: 'Görseli Kırp (344×194)',
    design1_crop_desc: 'Kırpma alanı 1. tasarım oranında kilitli.',
    visual_design2: '2. Tasarım Görseli (Liste / Poster)',
    visual_design2_hint: 'Dikey görsel 4:5 (1080×1350). Ana sayfa 2. tasarım listesi ve poster.',
    design2_crop_hint: '2. tasarım 4:5 (1080×1350). Kaydetmeden önce kırpın.',
    design2_crop_title: 'Görseli Kırp (4:5)',
    design2_crop_desc: 'Kırpma alanı 2. tasarım (4:5) oranında kilitli.',
    event_video: 'Etkinlik Videosu',
    video_hint:
      'Girişin tüm URL değil, yalnızca videonun ID’sini (?v= sonrası kod) içermesi gerektiğini lütfen unutmayın.',
    video_label: 'Video ID (Youtube ID)',
    venue_layout: 'Mekan Düzeni Görseli',
    layout_desc:
      'Bu etkinliğe özel bir mekan düzeni varsa yükleyin. Aksi takdirde mekanın varsayılan düzeni kullanılır.',
    layout_hint: 'Kare oranlı görseller yüklenmelidir. Her iki kenar da eşit olmalıdır.',
    change_image: 'Görseli Değiştir',
    add_image: 'Görsel Ekle',
    remove: 'Kaldır',
    crop_image_title: 'Görseli Kırp (4:5)',
    crop_image_desc:
      'Kırpma alanı 4:5 oranında kilitli. Alanı sürükleyip boyutunu ayarlayabilirsiniz.',
    cropping: 'Hazırlanıyor…',
    apply_crop: 'Kırp ve Uygula',
    payment_method_cc: 'Kredi Kartı',
    payment_method_doorcash: 'Kapıda Nakit Ödeme',
    slug_helper_text:
      'Benzersiz URL slug: sadece küçük harf a-z, 0-9 ve tire. Türkçe karakter kullanmayınız.',
    dress_code: 'Kıyafet Kuralı',
    dress_code_1: 'Günlük Kıyafet (Casual)',
    dress_code_2: 'Geldiğin Gibi Gel',
    dress_code_3: 'Şık / Şık Giyim (Elegant)',
    dress_code_4: 'Akıllı Günlük (Smart Casual)',
    dress_code_5: 'Kıyafet Kuralı Yok',
    couples_rule: 'Eş / Damsız Kuralı',
    couples_rule_1: 'Kural Yok',
    couples_rule_2: 'Erkeklerin Yanında Kadın Olmalı (Damsız Girilmez)',
    special_deal: 'Özel Kampanya / Fırsat Biletleri',
    reservation: 'Rezervasyon / Ön Satış',
    general_ticket: 'Genel Biletler',
    vip_list: 'VIP Biletler',
    extras: 'Ekstra Ürünler',
    invitations: 'Davetiyeler',
    invitations_hint: 'Misafirlerin etkinliğe katılması için davetiye grubu oluşturabilirsiniz.',
    all_fields_required: '(* tüm alanlar zorunlu)',
    title: 'Başlık',
    title_tr: 'Türkçe Başlık',
    title_en: 'İngilizce Başlık',
    price: 'Bilet Fiyatı (TL)',
    price_change_hint:
      'Mevcut bilet fiyatını değiştirmek istiyorsanız, yeni ürün oluşturup eski ürünü gizleyebilirsiniz.',
    sold: 'Satılan',
    ticket_stock: 'Stok',
    status: 'Durum',
    promotion_available: 'Promosyon Var mı?',
    promotion_label: 'Promosyon Etiketi',
    promotion_price: 'Promosyon Fiyatı',
    total_stock: 'Toplam Kontenjan / Stok',
    total_sold: 'Toplam Satılan (Bu seans için)',
    refundable: 'İade Edilebilir mi?',
    has_down_payment: 'Ön Ödeme (Depozito) Var mı?',
    down_payment_price: 'Ön Ödeme Tutarı',
    has_basket_limit: 'Sepet Limiti Var mı?',
    basket_limit: 'Kullanıcı Başı Sepet Limiti',
    ticket_status: 'Bilet Grubu Durumu',
    status_0: 'Satışta',
    status_1: 'Tükendi',
    status_2: 'Gizli',
    tickets: 'Biletler',
    coupons: 'Kuponlar',
    coupon_code: 'Kupon Kodu',
    discount_tl: 'İndirim Tutarı (TL)',
    stock: 'Kupon Stok Adedi',
    activeUntil: 'Son Geçerlilik Tarihi',
    active_until: 'Son Geçerlilik Tarihi',
    active_until_after_today: 'Son geçerlilik tarihi bugünden sonra olmalıdır.',
    active_until_before_start:
      'Son geçerlilik tarihi etkinlik başlangıç tarihinden önce olmalıdır.',
    system_params_error:
      'Sistem parametreleri yüklenemedi. Etkinliği kaydetmeden önce lütfen sistem yöneticisine bildirin.',
    service_fee: 'Etkinlik Hizmet Bedeli (TL)',
    service_fee_hint: 'Ek operasyonel giderleri karşılamak için alınan hizmet bedeli.',
    commission_fee: 'Etkinlik Komisyon Oranı (%)',
    is_commission_extra: 'Komisyon ekstradan mı eklensin (bilet fiyatına ilave)?',
    is_commission_extra_hint:
      'Bu seçenek açılırsa etkinlik bilet fiyatlarının değişeceğini lütfen unutmayın.',
    urgency_hours_label: 'Son X saat kala etiket göster',
    urgency_hours_threshold: 'X saat (eşik)',
    urgency_tickets_label: 'Son X bilet kala etiket göster',
    urgency_tickets_threshold: 'X bilet (eşik)',
    urgency_days_label: 'Son X gün kala etiket göster',
    urgency_days_threshold: 'X gün (eşik)',
    hours_threshold_required: 'Saat eşiği zorunludur.',
    valid_number_required: 'Geçerli bir sayı girin.',
    hours_threshold_min: 'Saat eşiği en az 1 olmalıdır.',
    hours_threshold_max: 'Saat eşiği en fazla %{max} olabilir.',
    hours_threshold_hint:
      'Etkinliğe bu kadar saat veya daha az kaldığında "Son N saat" etiketi gösterilir.',
    tickets_threshold_required: 'Bilet eşiği zorunludur.',
    tickets_threshold_min: 'Bilet eşiği en az 1 olmalıdır.',
    tickets_threshold_max: 'Bilet eşiği en fazla %{max} olabilir.',
    tickets_threshold_hint: 'Kalan bilet bu sayıya eşit/küçükse "Son N bilet" etiketi gösterilir.',
    days_threshold_required: 'Gün eşiği zorunludur.',
    days_threshold_min: 'Gün eşiği en az 1 olmalıdır.',
    days_threshold_max: 'Gün eşiği en fazla %{max} olabilir.',
    days_threshold_hint: 'Kalan gün bu değere eşit/küçükse "Son N gün" etiketi gösterilir.',
    refund_settings: 'İade Ayarları',
    refund_enabled: 'İade kabul edilsin mi?',
    refund_enabled_hint: 'Kapalıysa kullanıcılar bu etkinlik için web üzerinden iade yapamaz.',
    refund_deadline: 'İade son kabul tarih / saat',
    refund_deadline_error: 'İade son tarihi etkinlik başlangıcından sonra olamaz.',
    refund_deadline_hint:
      'Kullanıcılar bu tarih ve saate kadar iade yapabilir. Boş bırakılırsa süre sınırı yoktur.',
    refund_deadline_startdate_hint:
      'Önce etkinlik tarihini girin. Sonra iade için son kabul tarih/saat seçebilirsiniz.',
    show_event_on_website: 'Bu etkinliği web sitesinde göster',
    is_active_hint:
      'Bu değişikliğin geçerli olması için etkinliğin kaydedilmesi gerektiğini lütfen unutmayın.',
    verified_event: 'Onaylı Etkinlik mi?',
    is_verified_hint: 'Etkinlik yönetici tarafından onaylandı mı?',
    select_organisation_company: 'Organizasyon şirketi seçin…',
    select_venue: 'Mekan seçin…',
    select_category: 'Kategori seçin…',
    select_subcategory: 'Alt kategori seçin…',
  },
  show: {
    details: 'Detaylar',
    start: 'Başlangıç',
    end: 'Bitiş',
    sessions: 'Oturumlar / Seanslar',
    sessions_detail: '%{length} oturum (her biri %{duration} dakika)',
    verified: 'Onaylı mı',
    verified_yes: '✅ Evet - Web sitesinde ve mobil uygulamada gösteriliyor.',
    verified_no: '❌ Hayır - Web ve mobilde gösterilmek için onay bekliyor.',
    active: 'Yayında mı',
    active_yes: '✅ Evet - Etkinlik yayında ve bilet alınabilir.',
    active_no: '❌ Hayır - Etkinlik yayında değil ve bilet alınamaz.',
    event_link: 'Etkinlik Bağlantısı (Önizleme)',
    sales_summary: 'Satış Özeti',
    loading_sales_summary: 'Satış özeti yükleniyor…',
    transformed_summary_hint:
      'Dönüştürülen etkinlikler için satış özeti mevcut değildir, lütfen detaylar için satış raporunu kontrol edin.',
    total_product_sales: 'Toplam Ürün Satış Tutarı',
    total_sales_tickets: 'Toplam Satış / Bilet Adedi',
    total_seats: 'Toplam Koltuk Sayısı',
    sales_reports: 'Satışlar & Raporlar',
    sale_report: 'Satış Raporu',
    view_all_sales: 'Tüm Satışları Gör',
    view_all_tickets: 'Tüm Biletleri Gör',
    actions: 'İşlemler',
    view_sessions: 'Oturumları Gör',
    edit_event: 'Etkinliği Düzenle',
    seat_ops: 'Koltuk İşlemleri',
    cancel_event: 'Etkinliği İptal Et',
    clone_event: 'Etkinliği Klonla',
    cloning: 'Klonlanıyor…',
    homepage_visibility: 'Anasayfa Görünürlüğü',
    show_on_web: "Web'de Göster",
    hide_on_web: "Web'de Gizle",
    show_on_mobile: "Mobil'de Göster",
    hide_on_mobile: "Mobil'de Gizle",
    home_placements: 'Ana Sayfa Yer Seçimleri',
    home_placements_title: 'Ana Sayfa Yer Seçimleri',
    home_placements_desc:
      'Bu etkinliğin görüneceği ana sayfa bölümlerini seçin. Birden fazla section seçebilirsiniz.',
    home_placements_selected_count: '%{count} yer seçili',
    home_placements_hero: 'Ana Sayfa Özel Etkinlik Hero',
    home_placements_no_sections:
      'Seçilebilir özel section yok. Kategori seçili section’lar burada listelenmez.',
    home_placements_manual: 'Manuel etkinlik listesi',
    home_placements_auto: 'Otomatik yaklaşan (eklenince manuel’e geçer)',
    home_placements_has_image: 'Özel görsel seçildi',
    home_placements_selected: 'Seçili',
    home_placements_optional_image: 'Özel görsel opsiyonel',
    home_placements_featured_badge: 'Öne çıkan',
    home_placements_featured_hint: 'Seçince özel görsel sorulur (opsiyonel).',
    home_placements_auto_short: 'Otomatik → manuel',
    home_placements_ask_image_title: 'Özel görsel yüklemek ister misiniz?',
    home_placements_ask_image_desc:
      'Yüklemezseniz etkinlik banner görseli kullanılır. Ölçü hero kart ile aynıdır (275×344).',
    home_placements_skip_image: 'Hayır, görselsiz ekle',
    home_placements_yes_image: 'Evet, görsel yükle',
    home_placements_image_editor_title: 'Özel görsel',
    home_placements_or_url: 'veya görsel URL’si',
    home_placements_use_url: 'Kullan',
    home_placements_saved: 'Ana sayfa yerleşimleri kaydedildi.',
    pull_firebase: 'Son Hali Çek (Firebase)',
    pulling: 'Çekiliyor…',
    error_loading_event_data: 'Etkinlik verileri yüklenirken hata oluştu',
    delete_event: 'Etkinliği Sil',
    checking_sales: 'Satışlar kontrol ediliyor…',
    delete_event_desc:
      'Etkinliği nasıl kaldırmak istediğinizi seçin. Geçici silme (soft delete) tüm verileri korur ve etkinliği panel ve web sitesinde gizler.',
    cannot_verify_sales_warning:
      'Satışlar doğrulanamadı. Kalıcı silme işlemi satışlar kontrol edilene kadar devre dışıdır.',
    has_sales_warning:
      'Bu etkinlikte %{count} adet tamamlanmış satış var. Sadece geçici silme yapılabilir.',
    no_sales_notice:
      'Tamamlanmış bilet satışı bulunamadı. Geçici olarak gizleyebilir veya kalıcı olarak silebilirsiniz.',
    working: 'İşleniyor…',
    soft_delete: 'Geçici Sil (Gizle)',
    delete_permanently: 'Kalıcı Olarak Sil',
    hard_delete_confirm:
      'Bu işlem etkinliği ve tüm stok verilerini kalıcı olarak silecektir. Bu işlem geri alınamaz. Devam etmek istiyor musunuz?',
    could_not_verify_sales: 'Bu etkinlik için satışlar doğrulanamadı.',
    event_permanently_deleted: 'Etkinlik kalıcı olarak silindi.',
    event_soft_deleted: 'Etkinlik gizlendi (geçici silme).',
    failed_to_delete_event: 'Etkinlik silinirken hata oluştu.',
  },
  list: {
    all_events: 'Tüm Etkinlikler',
    upcoming_events: 'Yaklaşan Etkinlikler',
    pending_events: 'Bekleyen Etkinlikler',
    cancelled_events: 'İptal Edilen Etkinlikler',
    all_events_desc:
      'Yaklaşan etkinlikler: yayında, bekleyen ve iptal. Geçmiş etkinlikler burada yok.',
    upcoming_events_desc: 'Tarihi geçmemiş, yayında olan yaklaşan etkinlikler.',
    pending_events_desc: 'Tarihi geçmemiş, henüz yayına alınmamış etkinlikler.',
    cancelled_events_desc: 'Tarihi geçmemiş iptal edilmiş etkinlikler.',
    view: 'Görünüm',
    view_all: 'Tümü',
    view_upcoming: 'Yaklaşanlar',
    view_pending: 'Bekleyenler',
    view_cancelled: 'İptal edilenler',
    no_permission: 'Bu sayfayı görüntülemek için yeterli yetkiniz bulunmamaktadır.',
    pull_firebase_all: 'Firebase’den Hepsini Çek',
    pulling_firebase: 'Çekiliyor…',
    pull_firebase_confirm:
      'Firebase’deki TÜM mekan + org + event + bilet + satış kayıtları Postgres’e çekilsin mi?\n\nBu işlem uzun sürebilir. Postgres’te iade işaretli bilet/satışlar korunur.',
    pull_firebase_ok:
      'Pull OK: %{venues} mekan, %{orgs} org, %{events} event, %{sales} satış, %{tickets} bilet (%{failed} hata)',
    pull_firebase_error: 'Pull hata: %{message}',
  },
  create_wizard: {
    new_event: 'Yeni Etkinlik',
    step1_desc: 'Adım 1 / 2 — Etkinlik türünü seçin.',
    step2_desc: 'Adım 2 / 2 — Etkinlik tarih yapısını seçin.',
    event_type: 'Etkinlik Türü',
    date_type: 'Tarih Türü',
    back: 'Geri',
    next: 'İleri',
    step1_hint: 'Bir etkinlik türü seçin ve İleri butonuna tıklayın.',
    step2_hint: 'Tarih türünü seçin ve form ekranına geçmek için İleri butonuna tıklayın.',
    select_event_type_first: 'Lütfen önce bir etkinlik türü seçin.',
    select_date_type_first: 'Lütfen önce bir tarih türü seçin.',
    type_1_title: 'Standart Etkinlik',
    type_2_title: 'Alan Düzeni Etkinliği',
    type_3_title: 'Koltuk Düzenli Etkinlik',
    oneoff_title: 'Tek Tarihli Etkinlik',
    session_title: 'Çoklu Tarih / Seanslı',
    type1_desc: 'Koltuksuz veya alansız standart bilet satışı.',
    type2_desc: 'Mekan düzeni üzerinde alan / bölge bazlı bilet satışı.',
    type3_desc: 'Oturma planlı numaralı koltuk satışı.',
    oneoff_desc: 'Tek bir tarih ve saat içeren etkinlik.',
    session_desc: 'Bir etkinlik altında birden fazla tarih veya seans.',
  },
  pages: {
    active_events_title: 'Aktif Etkinlikler Listesi',
    active_events_desc:
      'Yetkiniz dahilindeki aktif etkinliklerin listesini aşağıda görebilirsiniz.',
    past_events_title: 'Geçmiş Etkinlikler Listesi',
    past_events_desc: 'İsim, slug, mekan, şehir veya kategori ile arama yapabilirsiniz.',
    pending_events_title: 'Onay Bekleyen Etkinlikler',
    push_notifications_title: 'Mobil Push Bildirim Gönderimi',
    push_notifications_desc: 'Eski mobil (Gişe Expo), yeni mobil ve web ayrı kanallar.',
    sale_report_title: 'Satış Raporu ve Hak Edişler',
  },
};
